import React, { useContext } from "react";
import "../Driveanalysis/GlossaryPage.css";
import { BsSkipBackwardCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import DashboardMain from "../DashboardMain/DashboardMain";
import AppContext from "../../../store/AppContext";
import { useState } from "react";

function GlossaryPage_Erc() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain>
        <body style={{ backgroundColor: "white" }}>
          <h1
            style={{ fontWeight: "bold", marginTop: "6em", fontSize: "2em" }}
            align="center"
          >
            Glossary Page
            <Link
              to="/dashboard/driveanalysis"
              style={{ color: "#32879c", marginLeft: "5%", fontSize: "0.7em" }}
            >
              <BsSkipBackwardCircleFill />
            </Link>
          </h1>
          <table
            className="table table-hover tableglosary"
            style={{ width: "50%", height: "20%" }}
            align="center"
          >
            <thead style={{ backgroundColor: "#32879c", color: "#fff" }}>
              <tr>
                <td>Sr.No.</td>
                <td>KPI Name</td>
                <td>Business logics</td>
                <td>Backend Formula</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Vehicle Count</td>
                <td>Count of Vehicle Chassis for seleted date range</td>
                <td>Count ( Distinct VIN )</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Total Km travelled</td>
                <td>Total Distance Covered for selected date range</td>
                <td>Sum (Median Delta ODO value of all vehicles)</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Median Range </td>
                <td>Median of Range in all discharge cycles of all vehicles</td>
                <td>
                  Median(Median Range in all discharge cycles of all vehicles)
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>Median Wh/km</td>
                <td>Median of Wh/km of all discharge cycles of all vehicles</td>
                <td>
                  Median(Median Wh/km of all discharge cycles of all vehicles)
                </td>
              </tr>
              <tr>
                <td>5</td>
                <td>Median discharge duration </td>
                <td>Median of Discharge duration of all vehicles</td>
                <td>Median(Median discharge duration of all vehicles)</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Idle Time Percentage</td>
                <td>Median of Idle Percent of all vehicles</td>
                <td>Median(Median Idle Time (%))</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Median regen percent</td>
                <td>Median of regen Percent of all vehicles</td>
                <td>Median(Median regen percent)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Med. BCS active Percent</td>
                <td>Median of BCS active time of all vehicles</td>
                <td>Median(Median BCS active time percent)</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Median BMS Max temperature</td>
                <td>Median of BMS Max cell Temp of all vehicles</td>
                <td>Median (Median BMS Max cell temperature)</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Median MCU Temp</td>
                <td>Median of MCU Temp of all vehicles</td>
                <td>Median (Median MCU temperature)</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Median Motor Temp</td>
                <td>Median of Motor Temp of all vehicles</td>
                <td>Median (Median Motor temperature)</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Median DCDC Temp</td>
                <td>Median of DCDC Temp of all vehicles</td>
                <td>Median (Medain DCDC temperature)</td>
              </tr>
            </tbody>
          </table>
        </body>
      </DashboardMain>
    </>
  );
}

export default GlossaryPage_Erc;
